import { downloadDocument } from '../../components/utilities/fileUtilities';
import { TitleStyles, GreyBackground } from './styles';
import { Link } from 'react-router-dom';
import { Order } from '../types';
import { BiFileBlank } from 'react-icons/bi';
import Iframe from '../../components/utilities/Iframe';
import { useState } from 'react';

interface Props {
  order: Order;
}

const Files = (props: Props) => {
  const [preview, setPreview] = useState({ iframeOpen: false, iframeUrl: '' });

  const handleOnClickPreview = (url: string) => {
    setPreview({ iframeOpen: true, iframeUrl: url });
  };
  return (
    <div style={{ marginTop: 24 }}>
      <TitleStyles>Files</TitleStyles>
      <GreyBackground style={{ textDecoration: 'underline', cursor: 'pointer' }}>
        {props.order?.documents.map(d => (
          <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
            <div onClick={() => downloadDocument(d.id)}>{d.customFileName || d.fileName} </div>
            <div
              onClick={() => handleOnClickPreview(`/api/utility/getDocument/${d.id}`)}
              style={{ marginLeft: 16 }}
            >
              <BiFileBlank color="#444" />
            </div>
          </div>
        ))}
      </GreyBackground>
      {preview.iframeOpen && (
        <Iframe
          url={preview.iframeUrl}
          onClose={() => setPreview({ iframeOpen: false, iframeUrl: '' })}
          width={'400px'}
        ></Iframe>
      )}
    </div>
  );
};

export default Files;
